import { createRef, useInstance, onMounted, nextTick } from 'intact-vue-next';
import { useState } from '../../hooks/useState';
import { isStringOrNumber, isNull } from 'intact-shared';
import { debounce } from '../utils';
import { useResizeObserver } from '../../hooks/useResizeObserver';
export function useStickyScrollbar(elementRef, _ref, tableRef, tableScroll) {
  var scrollRef = _ref.scrollRef,
    callbacks = _ref.callbacks;
  var instance = useInstance();
  var stick = useState(null);
  var style = useState(null);
  var scrollbarRef = createRef();
  var tableActualWidth = useState(null);
  instance.on('$receive:stickScrollbar', function (v) {
    stick.set(v === true ? 0 : isStringOrNumber(v) ? +v : null);
  });
  useResizeObserver(scrollRef, setTableActualWidth, true);
  onMounted(function () {
    setTableActualWidth();
  });
  callbacks.push(onTableScroll);
  var scrollLeft = 0;
  function shouldStickScrollbar(_ref2) {
    var offsetBottom = _ref2.offsetBottom,
      viewportHeight = _ref2.viewportHeight;
    var _elementRef$value$get = elementRef.value.getBoundingClientRect(),
      top = _elementRef$value$get.top,
      bottom = _elementRef$value$get.bottom;
    var p = viewportHeight - offsetBottom;
    if (bottom >= p && top < p) {
      style.set(null);
      // update scrollLeft, because it can not be updated when it is hidden
      nextTick(function () {
        scrollbarRef.value.scrollLeft = scrollLeft;
      });
      return true;
    } else {
      style.set({
        display: 'none'
      });
      return false;
    }
  }
  var lock = false;
  function onTableScroll(_scrollLeft) {
    if (isNull(stick.value) || lock) return;
    scrollbarRef.value.scrollLeft = scrollLeft = _scrollLeft;
  }
  var unlock = debounce(function () {
    return lock = false;
  }, 100);
  function onScroll(e) {
    lock = true;
    scrollRef.value.scrollLeft = scrollLeft = scrollbarRef.value.scrollLeft;
    unlock();
    tableScroll(scrollLeft);
  }
  function setTableActualWidth() {
    tableActualWidth.set(tableRef.value.offsetWidth + 'px');
  }
  return {
    shouldStickScrollbar: shouldStickScrollbar,
    stick: stick,
    style: style,
    scrollbarRef: scrollbarRef,
    onScroll: onScroll,
    tableActualWidth: tableActualWidth
  };
}